import { api } from "@/lib/api";

const CHUNK = 2 * 1024 * 1024;
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

async function withRetry(fn, signal, attempts = 3) {
  for (let i = 0; ; i++) {
    if (signal?.aborted) throw new DOMException("Annullato", "AbortError");
    try { return await fn(); } catch (e) {
      const status = e?.response?.status;
      if (signal?.aborted || e?.code === "ERR_CANCELED" || i >= attempts - 1 || (status && status < 500 && status !== 429)) throw e;
      await sleep(800 * (i + 1));
    }
  }
}

export async function uploadMedia(tournamentId, file, onProgress, signal) {
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  const type = file.type || "application/octet-stream";
  const { data: init } = await withRetry(() => api.post(`/tournaments/${tournamentId}/media/uploads`, { filename: file.name, content_type: type, size: file.size, total_chunks: total }, { signal }), signal);
  for (let i = 0; i < total; i++) {
    const blob = file.slice(i * CHUNK, Math.min(file.size, (i + 1) * CHUNK));
    await withRetry(() => api.put(`/tournaments/${tournamentId}/media/uploads/${init.upload_id}/${i}`, blob, { headers: { "Content-Type": "application/octet-stream" }, signal }), signal);
    onProgress?.(Math.round(((i + 1) / total) * 95), i + 1, total);
  }
  const { data } = await withRetry(() => api.post(`/tournaments/${tournamentId}/media/uploads/${init.upload_id}/complete`, null, { signal, timeout: 120000 }), signal, 2);
  onProgress?.(100, total, total);
  return data;
}

/** Ridimensiona in locale le foto da fotocamera oltre `maxEdge` px (restano ad alta qualità, ma pesano 3-5 volte meno). */
export async function shrinkImage(file, maxEdge = 4000, quality = 0.9) {
  if (!file.type.startsWith("image/") || file.type === "image/gif" || file.size < 3 * 1024 * 1024) return file;
  try {
    const bmp = await createImageBitmap(file, { imageOrientation: "from-image" });
    const scale = Math.min(1, maxEdge / Math.max(bmp.width, bmp.height));
    if (scale === 1) { bmp.close?.(); return file; }
    const canvas = document.createElement("canvas");
    canvas.width = Math.round(bmp.width * scale); canvas.height = Math.round(bmp.height * scale);
    canvas.getContext("2d").drawImage(bmp, 0, 0, canvas.width, canvas.height);
    bmp.close?.();
    const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", quality));
    if (!blob) return file;
    return new File([blob], file.name.replace(/\.[^.]+$/, "") + ".jpg", { type: "image/jpeg", lastModified: file.lastModified });
  } catch { return file; }
}

export const mediaUrl = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);
